import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useClientAuth } from "@/context/ClientAuthContext";
import { AuthShell, AuthInput, SubmitButton, usePending, Lock } from "@/components/portal/AuthShell";

export default function PortalActivate() {
  const { activate } = useClientAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, run] = usePending();

  const submit = (e) => {
    e.preventDefault();
    if (pw.length < 8) return toast.error("8 caractères minimum");
    if (pw !== pw2) return toast.error("Les mots de passe ne correspondent pas");
    run(async () => {
      try { await activate(token, pw); toast.success("Compte activé"); navigate("/espace-client"); }
      catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    });
  };

  return (
    <AuthShell title="Activer mon accès" subtitle="Choisissez votre mot de passe pour accéder à votre Espace client.">
      {!token ? <p className="text-sm text-rose-600" data-testid="portal-activate-missing">Lien d'activation invalide.</p> : (
        <form onSubmit={submit} className="space-y-4" data-testid="portal-activate-form">
          <AuthInput icon={Lock} type="password" required value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Nouveau mot de passe (8+ caractères)" data-testid="portal-activate-password" />
          <AuthInput icon={Lock} type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirmer le mot de passe" data-testid="portal-activate-password-confirm" />
          <SubmitButton loading={loading} data-testid="portal-activate-submit">Activer mon compte</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
